module.exports = __webpack_public_path__ + "static/media/edit-green-circle.902bbbd5.svg";